<template>
  <!-- 
  url: "/product/participate/act-goods/"
  url: "/product/activity/h5/" 
  数据结构暂时没有接口，用的是上面的 两个接口 合并的
-->
  <div class="item" :class="{ noStart: !activityState }" @click="toGoodsDetail">
    <!-- 图片 -->
    <custom-image
      :width="$attrs.imgWidth"
      :height="$attrs.imgHeight"
      :src="data.goodsImage"
      :tag="imgTextTag"
      :fit="$attrs.fit"
      v-bind="$attrs"
      style="
        content-visibility: auto;
        contain-intrinsic-size: 1vh;
        -moz-contain-intrinsic-size: 1vh;
        -webkit-contain-intrinsic-size: 1vh;
      "
    >
      <slot name="imgText">
        <span v-if="data.buyQuantity && activityState">
          {{
            data.buyQuantity > 100 ? data.buyQuantity + "+" : data.buyQuantity
          }}人付款
        </span>
        <span v-if="!activityState">预售中</span>
      </slot>
    </custom-image>
    <div class="content" style="height: 98px">
      <!-- 标题 -->
      <slot name="title">
        <CardTitle
          class="goods-card-title"
          :data="data"
          :coupons="coupons"
          :activityState="activityState"
        ></CardTitle>
      </slot>
      <slot name="amount">
        <!-- 商品价格 -->
        <CardPrice
          class="goods-card-price"
          :data="data"
          :activityState="activityState"
        />
      </slot>
    </div>
    <!-- 计时器距活动结束时间 -->
    <Countdown
      v-show="false"
      :startTime="data.start"
      :endTime="data.end"
      @activityStateChange="activityStateChange"
    />
  </div>
</template>

<script>
import Countdown from "@/components/activity/Countdown";
import CustomImage from "@/components/custom-image";
import CardTitle from "@/components/card/components/CardTitle";
import CardPrice from "@/components/card/components/CardPrice";
export default {
  components: { Countdown, CustomImage, CardTitle, CardPrice },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    coupons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activityState: true,
    };
  },
  computed: {
    imgTextTag() {
      return this.activityState ? "sale-num" : "pre-sale";
    },
  },
  methods: {
    toGoodsDetail() {
      const routeName = this.$route.name;
      if (routeName === "ActivityPlace") {
        this.$router.push({
          name: "ActivityPlaceGoodsDetail",
          params: { id: this.data.partGoodsId },
        });
      } else if (routeName === "Newcomer") {
        this.$router.push({
          name: "NewcomerGoodsDetail",
          params: { id: this.data.partGoodsId },
        });
      } else {
        this.$router.push({
          path: "/homeGoodsDetail/" + this.data.partGoodsId,
        });
      }
    },
    shareClick() {
      if (this.data.state === "FINISHED") {
        Toast({
          message: "活动已结束",
          position: "center",
          duration: 1000,
        });
        return;
      }
      this.$store.dispatch("shareGoods/show", {
        params: {
          partId: this.data.partId,
          actId: this.data.actId,
          partGoodsId: this.data.partGoodsId,
          goodsId: this.data.goodsId,
        },

        shareOptions: {
          title: this.data.goodsName,
          desc: this.data.activityName,
          imgUrl: this.data.goodsImg,
        },
      });
    },
    // 实时获取开始状态
    activityStateChange(flag) {
      this.activityState = flag;
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  height: fit-content;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);

  .goods-card-price,
  .goods-card-title {
    /* px-to-viewport-ignore-next */
    padding-left: 11px;
  }
}

.item.noStart {
  .content .amount .right {
    background: linear-gradient(304deg, #44d7b6 0%, #baffef 100%);
  }
}
</style>
